module.exports = __webpack_public_path__ + "img/estante-virtual-cover.a33e32f8.jpg";